import React from "react";
import { Card } from "react-bootstrap";
import { primaryColor } from "../config/colors";
import { strings } from "../localization";

function Loading() {
  return (
    <Card className="flex-grow-1 d-fkex flex-column justify-content-center align-items-center">
      <span
        className="spinner-border spinner-border-lg mx-1"
        role="status"
        aria-hidden="true"
        style={{
          color: primaryColor,
          fontSize: 20,
        }}
      ></span>
      <p style={{ color: primaryColor, fontSize: 20, marginTop: 10 }}>
        {strings.loading}..
      </p>
    </Card>
  );
}

export default Loading;
